export const AnalyticsEventTypes = {
  // Navigation events
  PAGE_VIEW: 'page_view',
  SECTION_CHANGE: 'section_change',
  ROUTE_CHANGE: 'route_change',
  TIME_ON_PAGE: 'time_on_page',

  // User actions
  TASK_COMPLETED: 'task_completed',
  /* The counter-event to TASK_COMPLETED. Without it a child unticking and
     re-ticking a row inflates `task_completed` indefinitely, and the funnel has
     no way to net it off — completions are one of the few numbers this product
     reports on itself, so they have to be honest. */
  TASK_UNCOMPLETED: 'task_uncompleted',
  TASK_CREATED: 'task_created',
  TASK_DELETED: 'task_deleted',
  TASK_UPDATED: 'task_updated',
  ROUTINE_CREATED: 'routine_created',
  ROUTINE_DELETED: 'routine_deleted',
  ROUTINE_UPDATED: 'routine_updated',
  REWARD_CREATED: 'reward_created',
  REWARD_UPDATED: 'reward_updated',
  REWARD_REMOVED: 'reward_removed',
  REWARD_CLAIMED: 'reward_claimed',
  ACTION_CREATED: 'action_created',
  ACTION_UPDATED: 'action_updated',
  ACTION_REMOVED: 'action_removed',
  ACTION_RECORDED: 'action_recorded',
  EMOTION_RECORDED: 'emotion_recorded',
  EMOTION_UPDATED: 'emotion_updated',
  EMOTION_REMOVED: 'emotion_removed',
  SLEEP_STARTED: 'sleep_started',
  SLEEP_OCCURRENCE: 'sleep_occurrence',
  SLEEP_ENDED: 'sleep_ended',
  CHILD_INVITED: 'child_invited',
  CHILD_REMOVED: 'child_removed',
  CHILD_ADDED: 'child_added',
  EDUCATOR_INVITED: 'educator_invited',
  EDUCATOR_REMOVED: 'educator_removed',
  THERAPIST_INVITED: 'therapist_invited',
  THERAPIST_REMOVED: 'therapist_removed',
  INVITATION_ACCEPTED: 'invitation_accepted',
  INVITATION_DECLINED: 'invitation_declined',
  OOBE_TERMS_ACCEPTED: 'oobe_terms_accepted',
  OOBE_TERMS_DECLINED: 'oobe_terms_declined',
  OOBE_FAMILY_CREATE_STARTED: 'oobe_family_create_started',
  OOBE_FAMILY_CREATE_FAILED: 'oobe_family_create_failed',
  OOBE_FAMILY_CREATED: 'oobe_family_created',
  OOBE_CONTINUE_BLOCKED: 'oobe_continue_blocked',
  OOBE_COMPLETED: 'oobe_completed',

  // Feature usage
  FEATURE_USED: 'feature_used',
  SETTINGS_CHANGED: 'settings_changed',
  /* Which routine view a child actually uses, and whether they switch.
     Whole-sequence vs current-step has NO literature in either direction —
     this is the one place the product can generate evidence. Named counters
     only: never a behavioural record (design spec §4). */
  ROUTINE_VIEW_SHOWN: 'routine_view_shown',
  ROUTINE_VIEW_CHANGED: 'routine_view_changed',

  // System events
  ERROR_OCCURRED: 'error_occurred',
  PERFORMANCE_METRIC: 'performance_metric',

  // User preferences
  CONSENT_CHANGED: 'consent_changed',
  THEME_CHANGED: 'theme_changed',
} as const;
export type AnalyticsEventType =
  (typeof AnalyticsEventTypes)[keyof typeof AnalyticsEventTypes];
